// Premium styles for the new homepage layout
export const premiumHomeStyles = `
.home-grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); /* 进一步增加最小宽度使框更大 */
  gap: 2.5rem; /* 增加间距 */
  padding: 2.5rem; /* 增加内边距 */
  max-width: 1800px; /* 进一步增加最大宽度 */
  margin: 0 auto;
  width: 100%;
  height: auto;
  min-height: 80vh; /* 增加最小高度 */
}

.home-grid-item {
  background: #ffffff;
  border: 1px solid #c8e6c9;
  border-radius: 8px;
  overflow: visible; /* 改为 visible 确保内容不会被裁剪 */
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2.5rem; /* 增加内边距 */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  text-decoration: none;
  min-height: 220px; /* 使用最小高度而不是固定高度 */
  height: auto; /* 允许高度自适应内容 */
  animation: fadeIn 0.5s ease-out;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.home-grid-item:hover {
  transform: translateY(-5px);
  border-color: #4caf50;
  box-shadow: 0 10px 25px rgba(76, 175, 80, 0.2);
  background: linear-gradient(145deg, #f1f8e9, #ffffff);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.home-grid-item-title {
  color: var(--color-text-primary);
  font-size: 1.7rem; /* 进一步增加标题字体大小 */
  font-weight: 600;
  margin-bottom: 0.7rem;
  letter-spacing: 0.02em;
  font-family: "Playfair Display", Georgia, serif;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  white-space: normal; /* 允许标题换行 */
}

.home-grid-item-image {
  width: 110px;
  height: 110px;
  object-fit: contain;
  margin: 0.7rem 0;
  transition: all 0.3s ease;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.home-grid-item:hover .home-grid-item-image {
  transform: scale(1.1);
  filter: drop-shadow(0 4px 8px rgba(255, 255, 255, 0.2));
}

.home-grid-item:hover .home-grid-item-title {
  color: #000000;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.home-grid-item-desc {
  color: var(--color-text-secondary);
  font-size: 1.2rem; /* 增加描述字体大小 */
  line-height: 1.7;
  margin: 0;
  letter-spacing: 0.02em;
  white-space: normal; /* 允许描述换行 */
}

/* 移除特定的行列定位，让网格自动排列 */

/* Responsive design */
@media (max-width: 1200px) {
  .home-grid-container {
    gap: 2rem;
    padding: 2rem;
    min-height: 70vh;
  }
  
  .home-grid-item {
    padding: 2rem;
    min-height: 200px; /* 调整最小高度 */
  }
  
  .home-grid-item-title {
    font-size: 1.6rem;
    margin-bottom: 0.6rem;
  }
  
  .home-grid-item-image {
    width: 100px;
    height: 100px;
    margin: 0.5rem 0;
  }
  
  .home-grid-item-desc {
    font-size: 1.1rem;
  }
}

@media (max-width: 992px) {
  .home-grid-container {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
    padding: 1.5rem;
  }
  
  .home-grid-item {
    padding: 1.5rem;
    min-height: 180px;
  }
  
  .home-grid-item-title {
    font-size: 1.5rem;
  }
  
  .home-grid-item-image {
    width: 90px;
    height: 90px;
    margin: 0.4rem 0;
  }
  
  .home-grid-item-desc {
    font-size: 1rem;
  }
  
  /* 在中等屏幕下也使用自动排列 */
}

@media (max-width: 768px) {
  .home-grid-container {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.2rem;
    padding: 1.2rem;
    min-height: auto;
  }
  
  .home-grid-item {
    padding: 1.2rem;
    min-height: 160px; /* 响应式下降低最小高度 */
  }
  
  .home-grid-item-title {
    font-size: 1.4rem;
    margin-bottom: 0.5rem;
  }
  
  .home-grid-item-image {
    width: 80px;
    height: 80px;
    margin: 0.3rem 0;
  }
  
  .home-grid-item-desc {
    font-size: 0.95rem;
  }
  
  /* 在小屏幕下也使用自动排列 */
}

@media (max-width: 576px) {
  .home-grid-container {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1rem;
  }
  
  .home-grid-item {
    padding: 1rem;
    min-height: 150px;
  }
  
  .home-grid-item-title {
    font-size: 1.3rem;
  }
  
  .home-grid-item-image {
    width: 70px;
    height: 70px;
    margin: 0.2rem 0;
  }
  
  .home-grid-item-desc {
    font-size: 0.9rem;
  }
}

/* 添加淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`;

export const injectStyles = () => {
  const styleElement = document.createElement('style');
  styleElement.innerHTML = premiumHomeStyles;
  document.head.appendChild(styleElement);
};